import {
    ABSENCES_SAGA_GET_CURRENT_PAYROLL_PERIOD,
    ABSENCES_SAGA_GET_EMPLOYEE_LOKET_BALANCES,
} from '../actionTypes'
import { GetEmployeeLoketBalances } from './absencesModel'

export const getCurrentPayrollPeriod = () => ({ type: ABSENCES_SAGA_GET_CURRENT_PAYROLL_PERIOD })

export const getEmployeeLoketBalances = (loketEmployeeId: string): GetEmployeeLoketBalances => ({
    type: ABSENCES_SAGA_GET_EMPLOYEE_LOKET_BALANCES,
    loketEmployeeId,
})
